// First-party analytics: anonimo, GDPR-friendly (no cookie, session volatile)
const API = `${window.location.origin}/api`;

const SECTION_IDS = [
  "collezione", "filosofia", "terra-arsa", "scilla", "blanche", "claire",
  "artigianalita", "sommelier-club", "faq", "contatti",
];

function sid() {
  let s = sessionStorage.getItem("vdi-sid");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("vdi-sid", s);
  }
  return s;
}

function deviceType() {
  const ua = navigator.userAgent;
  if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (navigator.maxTouchPoints > 1 && /Macintosh/i.test(ua))) return "tablet";
  if (/Mobi|Android|iPhone/i.test(ua)) return "mobile";
  return "desktop";
}

function send(payload, useBeacon = false) {
  const body = JSON.stringify({ session_id: sid(), ...payload });
  if (useBeacon && navigator.sendBeacon) {
    navigator.sendBeacon(`${API}/analytics/track`, new Blob([body], { type: "application/json" }));
  } else {
    fetch(`${API}/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  }
}

async function loadClarity() {
  try {
    const r = await fetch(`${API}/analytics/clarity-id`);
    const { project_id } = await r.json();
    if (!project_id || window.clarity) return;
    (function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", project_id);
  } catch (e) { /* noop */ }
}

export function initAnalytics() {
  if (window.__vdiAnalytics) return;
  window.__vdiAnalytics = true;

  const params = new URLSearchParams(window.location.search);
  send({
    type: "pageview",
    path: window.location.pathname,
    referrer: document.referrer || "",
    utm_source: params.get("utm_source") || "",
    utm_medium: params.get("utm_medium") || "",
    device: deviceType(),
  });

  loadClarity();

  const startedAt = Date.now();
  const secTimes = {};
  const visibleSince = {};

  const observer = new IntersectionObserver(
    (entries) => {
      const now = Date.now();
      entries.forEach((en) => {
        const id = en.target.id;
        if (en.isIntersecting) {
          visibleSince[id] = now;
        } else if (visibleSince[id]) {
          secTimes[id] = (secTimes[id] || 0) + (now - visibleSince[id]) / 1000;
          delete visibleSince[id];
        }
      });
    },
    { threshold: 0.35 }
  );
  const attach = () => {
    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
  };
  setTimeout(attach, 1500);

  let flushed = false;
  const flush = () => {
    if (flushed) return;
    flushed = true;
    const now = Date.now();
    Object.keys(visibleSince).forEach((id) => {
      secTimes[id] = (secTimes[id] || 0) + (now - visibleSince[id]) / 1000;
    });
    send({ type: "duration", seconds: (now - startedAt) / 1000 }, true);
    const sections = Object.entries(secTimes)
      .filter(([, s]) => s >= 1)
      .map(([id, seconds]) => ({ id, seconds: Math.round(seconds * 10) / 10 }));
    if (sections.length) send({ type: "sections", sections }, true);
  };
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flush();
  });
  window.addEventListener("pagehide", flush);
}

export function trackQrScan(wine) {
  const key = `vdi-qr-${wine}`;
  if (sessionStorage.getItem(key)) return; // una scansione per sessione
  sessionStorage.setItem(key, "1");
  send({ type: "qr_scan", wine, device: deviceType() });
}
